import { createSelector } from 'reselect'

const getGuruChatState = state => state.guruChat

export const selectGuruChatMessages = createSelector(
  getGuruChatState,
  state => state.messages
)

export const selectGuruChatIsLoading = createSelector(
  getGuruChatState,
  state => state.isLoading
)

export const selectGuruChatToolStatus = createSelector(
  getGuruChatState,
  state => state.toolStatus
)

export const selectGuruChatStreamingText = createSelector(
  getGuruChatState,
  state => state.streamingText
)

export const selectGuruChatActiveAction = createSelector(
  getGuruChatState,
  state => state.activeAction
)

export const selectGuruChatError = createSelector(
  getGuruChatState,
  state => state.error
)
